import React from 'react'
import texts from '../../../../common/texts.json'
import './index.css'

function OurCompanies() {
  return (
    <div className="our-companies__main-container">
      <div className="our-companies__companies-list">
        <p className="our-companies__companie-list-item--title">{texts.FOOTER.OUR_COMPANIES_TITLE}</p>
        <a
          href="http://www.walmartchile.cl/"
          className="our-companies__companie-list-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="walmart-chile" height={34} src="/catalogo/images/wmt_chile.webp" />
        </a>
        <a
          href="https://www.lider.cl/"
          className="our-companies__companie-list-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="lider" height={34} src="/catalogo/images/lider.webp" />
        </a>
        <a
          href="https://www.lider.cl/"
          className="our-companies__companie-list-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="lider-express" height={34} src="/catalogo/images/express.webp" />
        </a>
        <a
          href="https://acuenta.cl/"
          className="our-companies__companie-list-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="acuenta" height={34} src="/catalogo/images/acuenta.webp" />
        </a>
        <a
          href="https://www.centralmayorista.cl/"
          className="our-companies__companie-list-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="central-mayorista" height={34} src="/catalogo/images/central_mayorista.webp" />
        </a>
        <a
          href="http://www.miclublider.cl/"
          className="our-companies__companie-list-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="mi-club-lider" height={34} src="/catalogo/images/mi_club_lider.svg" />
        </a>
      </div>
      <div className="our-companies__divider-container">
        <div className="our-companies__divider" />
      </div>
      <div className="our-companies__final-text-container">
        <p className="our-companies__final-text">{texts.FOOTER.LEGAL_INFO}</p>
      </div>
    </div>
  )
}

export default OurCompanies
